export default [

     {
          path: 'user',
          alias: ['/users', '/User', '/Users'],
          name: 'User',
          component: () => import("@/views/Page/User/User.vue"),
           meta: {
               title: 'User Management',
          },
     },
     {
          path: 'profile',
          name: 'Profile',
          component: () => import("@/views/Page/User/Profile.vue"),
           meta: {
               title: 'Profile',
          },
     }
];